import React, { useEffect, useState } from 'react';
import './ITServicesPage.css';
import Chatbot from './Chatbot'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMicrochip,
  faHospital,
  faShoppingCart,
  faUniversity,
  faTruck,
  faSuitcase,
  faBook,
  faIndustry,
  faUtensils,
  faBed,
  faBuilding,
  faCar
} from '@fortawesome/free-solid-svg-icons'
// import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import { faProjectDiagram, faChartLine, faCogs, faLaptopCode, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from './ThemeContext';
import { FaUserTie, FaCogs, FaShieldAlt, FaHeadset } from 'react-icons/fa';


import cloudimg from './images/It-service_1/herocloud.avif'

import about from './images/It-service_1/about-back1.avif'

import aws from './images/It-service_1/aws.avif'
import html from './images/It-service_1/html.avif'
import photoshop from './images/It-service_1/photoshop.avif'
import illustrator from './images/It-service_1/illustrator.avif'
import javascript from './images/It-service_1/javascript.avif'

import cutting from './images/It-service_1/cuttingedge_1.avif'
import expert from './images/It-service_1/expertteam.avif'
import solution from './images/It-service_1/solution1.jpg'
import customer from './images/It-service_1/customersatifactionNew.avif'
import comprehensive from './images/It-service_1/comprehensive.avif'
import rapid from './images/It-service_1/rapid.jpg'
import customized from './images/It-service_1/customize.jpg'



const technologies = [
  {
    name: 'HTML',
    icon: html,
  },
  {
    name: 'CSS',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/544px-CSS3_logo_and_wordmark.svg.png',
  },
  {
    name: 'Figma',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg',
  },
  {
    name: 'Photoshop',
    icon: photoshop,
  },
  {
    name: 'Illustrator',
    icon: illustrator,
  },
  {
    name: 'JavaScript',
    icon: javascript,
  },
  {
    name: 'React',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg',
  },
  {
    name: 'Node.js',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg',
  },
  {
    name: 'Aws',
    icon: aws,
  },
  {
    name: 'Angular',
    icon: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Angular_full_color_logo.svg/768px-Angular_full_color_logo.svg.png',
  },
  {
    name: 'MongoDB',
    icon: 'https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg',
  },
];




const data = [
  { 
    heading: 'Cutting-Edge Technology Solutions', 
    text: 'Innovating Today, Empowering Tomorrow.\n Experience the future with our latest tech solutions, crafted to keep your business ahead.', 
    subtext: 'Experience the future with our latest tech solutions, crafted to keep your business ahead.',  
    imageUrl: cutting 
  },
  { 
    heading: 'Expert & Dedicated Team Members', 
    text: 'Your Success, Our Commitment.\n Our skilled team is passionate about helping you succeed. We’re with you every step of the way.', 
    subtext: 'Our skilled team is passionate about helping you succeed. We’re with you every step of the way.',  
    imageUrl: expert 
  },
  { 
    heading: '24/7 Free Technical Support', 
    text: 'Always Here, Always Ready.\n Need help at any hour? Our support team is here for you, day and night.', 
    subtext: 'Need help at any hour? Our support team is here for you, day and night.',  
    imageUrl: solution 
  },
  { 
    heading: '100% Customer Satisfaction', 
    text: 'Your Satisfaction, Our Promise.\n We’re dedicated to making sure you’re happy with our services. Your smile is our success.', 
    subtext: 'We’re dedicated to making sure you’re happy with our services. Your smile is our success.',  
    imageUrl: customer 
  },
  { 
    heading: 'Comprehensive IT Consultation', 
    text: 'Strategic Insights for Sustainable Growth.\n Get expert advice tailored to your needs, helping your business grow smartly.', 
    subtext: 'Get expert advice tailored to your needs, helping your business grow smartly.',  
    imageUrl: comprehensive 
  },
  { 
    heading: 'Rapid Response to Critical Issues', 
    text: 'Swift Solutions, Secure Operations.\n When it matters most, our team is on it. We solve problems quickly to keep you running smoothly.', 
    subtext: 'When it matters most, our team is on it. We solve problems quickly to keep you running smoothly.',  
    imageUrl: rapid 
  },
  { 
    heading: 'Customized IT Strategies', 
    text: 'Tailored Strategies, Tangible Results.\n Our custom IT plans are designed just for you, ensuring you get real results.', 
    subtext: 'Our custom IT plans are designed just for you, ensuring you get real results.',  
    imageUrl: customized 
  }
];



const ITServicesPage = () => {

  const { theme } = useTheme();




  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate API call or page load delay
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust time as per your requirement
  }, []);



  const flipCard = document.querySelectorAll('.flip-card');

  flipCard.forEach((card) => {
    const flipToBack = card.querySelector('.flip-back');
    const flipToFront = card.querySelector('.flip-front');

    flipToBack.addEventListener('click', () => {
      card.classList.add('flipped');
    });

    flipToFront.addEventListener('click', () => {
      card.classList.remove('flipped');
    });
  });













  // Technologies Carousel State and Handlers



  const [currentTechIndex, setCurrentTechIndex] = useState(0);

  // Auto-slide effect
  useEffect(() => {
    const techInterval = setInterval(() => {
      handleNextTech();
    }, 3000);

    return () => clearInterval(techInterval);
  }, [currentTechIndex]);

  // Move to the previous set of technologies
  const handlePreviousTech = () => {
    setCurrentTechIndex((prevIndex) =>
      (prevIndex - 4 + technologies.length) % technologies.length
    );
  };

  // Move to the next set of technologies
  const handleNextTech = () => {
    setCurrentTechIndex((prevIndex) => (prevIndex + 4) % technologies.length);
  };

  // Get the four technologies to display
  const getVisibleTechs = () => {
    const start = currentTechIndex;
    const end = (start + 4) % technologies.length;

    // Handle wrapping of the carousel
    if (end < start) {
      return [
        ...technologies.slice(start, technologies.length),
        ...technologies.slice(0, end),
      ];
    }

    return technologies.slice(start, end);
  };

  const visibleTechs = getVisibleTechs();





  const [currentIndex, setCurrentIndex] = useState(0);


  const handleNext = () => {
    setCurrentIndex((currentIndex + 1) % data.length);
  };

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + data.length) % data.length);
  };





  






  

  // hero section logic
  const slides = [
    {
      heading: "AI and Generative Intelligence Solution",
      text: "Empowering Your Future with AI and Generative Intelligence. Let's shape a brighter, more innovative tomorrow together.",
      imgUrl: "https://media.istockphoto.com/id/1308610989/photo/shot-of-a-young-female-call-center-agent-working-in-office-stock-photo.webp?a=1&b=1&s=612x612&w=0&k=20&c=d5IbTyZAhUnYpZeBpkmJBIDK1t-IwyXmSUbFTjuNC6o=",
    },
    {
      heading: "Software Development",
      text: "Crafting Your Digital Future with Precision and Passion. Let's build innovative solutions together.",
      imgUrl: "https://images.unsplash.com/photo-1590650589327-3f67c43ad8a2?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      heading: "Web Development",
      text: "Designing Engaging Web Experiences with Creativity and Expertise. Let's bring your vision to life.",
      imgUrl: "https://plus.unsplash.com/premium_photo-1683134157126-2f0cfd8ee388?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      heading: "Cloud Computing",
      text: "Empower Your Business with Cloud Excellence. Together, we create seamless, scalable solutions for a brighter future.",
      imgUrl: cloudimg,
    },
  ];

  const [activeSlide, setActiveSlide] = useState(0);


  useEffect(() => {
    const autoSlide = setInterval(() => {
      setActiveSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 3000);

    return () => clearInterval(autoSlide);
  }, [slides.length]);


  const showNextSlide = () => {
    setActiveSlide((activeSlide + 1) % slides.length);
  };

  const showPrevSlide = () => {
    setActiveSlide((activeSlide - 1 + slides.length) % slides.length);
  };


  return (

<>
      {loading ? (
        <div id="loader" className="loader">
          <img src="/static/images/favicon.png" alt="Logo" />
          <p className="loading-text">
            Please wait for a moment. The page is loading...
          </p>
        </div>
      ) : (



    <div className={`IT-container page-content ${theme}`}>


      <div
        className="hero-main"
        style={{ backgroundImage: `url(${slides[activeSlide].imgUrl})` }}
      >
        <div className="hero-subcontent">
          <h1>{slides[activeSlide].heading}</h1>
          <p>{slides[activeSlide].text}</p>
          <div className="herobtn">
            <button
              onClick={() => {
                switch (activeSlide) {
                  case 0:
                    window.location.href = '#card2';
                    break;
                  case 1:
                    window.location.href = '#card1';
                    break;
                  case 2:
                    window.location.href = '#card3';
                    break;
                  case 3:
                    window.location.href = '#card6';
                    break;
                  default:
                    window.location.href = '#mainContainer';
                }
              }}
              className="hero-button1 apply-right-arrow"
            >
              Our Services
              <svg
                className="arrow-icon"
                fill="none"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                  fill="currentColor"
                />
              </svg>
            </button>

            <a href="/business-form">
              <button onClick={() => window.location.href = '#mainContainer'} className="hero-button2 apply-right-arrow">
                Connect Now
                <svg
                  className="arrow-icon"
                  fill="none"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                    fill="currentColor"
                  />
                </svg>
              </button>
            </a>
          </div>
          <button className="hero-arrow left-arrow" onClick={showPrevSlide}>
            &#10094;
          </button>
          <button className="hero-arrow right-arrow" onClick={showNextSlide}>
            &#10095;
          </button>
        </div>
      </div>


      <h2 class="home-about-us">About Us</h2>
      <section className="about-us fade-in">
      <div className="about-us-inner">
        <div className="about-us-image image-slide">
          <img 
            src={about} 
            alt="About Us"
          />
        </div>

        <div className="about-us-content text-slide">
          <p className="one"> <b style={{ fontWeight: 600 }}> United in Growth, United in Success,</b> At the heart of our mission is the belief that growth and technology go hand in hand. Through collaboration and precision, we achieve incredible things together. Our tailored IT services, from consultation to implementation, empower your digital journey with innovative solutions. Committed to keeping you ahead of the curve, we offer future-ready, scalable, and secure solutions. Partner with us to navigate the digital landscape with confidence and achieve remarkable heights.</p>
          <h3>"Let's grow Together"</h3>
          <a href="./about-us.html" style={{ color: "#FB6200" }}>
            Explore More
          </a>
        </div>
      </div>
    </section>



    <hr className="dividenew" />



    <div className="custom-carousel-container">
  <h2 className="subHeading">How We Provide IT Solutions</h2>
  <div
    className="custom-carousel-slide"
    style={{ backgroundImage: `url(${data[currentIndex].imageUrl})` }}
  >
    <div className="custom-carousel-content">
      {/* Heading */}
      <h2>{data[currentIndex].heading}</h2>

      {/* Main Text */}
      <p>{data[currentIndex].text.split('\n')[0]}</p>

      {/* Subtext */}
      <p className="subtext">{data[currentIndex].subtext}</p>
    </div>
  </div>

  {/* Carousel Arrows */}
  <button className="custom-carousel-arrow left-arrow" onClick={handlePrev}>
    &#10094;
  </button>
  <button className="custom-carousel-arrow right-arrow" onClick={handleNext}>
    &#10095;
  </button>
</div>

      <hr className="dividenew" />


      {/* service section */}
      <div id="mainContainer">
      <p className="section-description">
          "Partnering with You by Providing IT Solution to transform challenges into opportunities, empowering your business to grow and innovate."
        </p>
        <h2 className="section-title subHeading">Our Services</h2>
        

        <div className="mainContainerInner">

          {/* card1 */}
          <div className="flip-card" id='card1'>
            <div className="flip-card-inner">
              <div className="flip-card-front flipSoftware">
                <h3>Software Development</h3>
                <p>Building the Future, One Line of Code at a Time.<br />
                  Custom software tailored to your needs.
                </p>
                <button className='flip-back apply-right-arrow'>
                  Read More
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>

              <div className="flip-card-back it-software">
                <p>Discover our software development services that offer tailored solutions to meet your unique business requirements, from conceptualization to deployment.</p>
                <button className='flip-front apply-right-arrow'>
                  Go back
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* card2 */}

          <div className="flip-card" id='card2'>
            <div className="flip-card-inner">
              <div className="flip-card-front flipUi">
                <h3>UI & UX Design</h3>
                <p>Designing User-Centric Experiences<br />
                  Intuitive and engaging interface design.
                </p>
                <button className='flip-back apply-right-arrow'>
                  Read More
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>

              <div className="flip-card-back it-ui">
                <p>Uncover our UX & UI design services that focus on creating intuitive and engaging interfaces, enhancing user experience and satisfaction with seamless and aesthetically pleasing designs.</p>
                <button className='flip-front apply-right-arrow'>
                  Go back
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>


          {/* card3 */}
          <div className="flip-card" id='card3'>
            <div className="flip-card-inner">
              <div className="flip-card-front flipWeb">
                <h3>Web Development</h3>
                <p>Creating Engaging Digital Experiences.<br />
                  Responsive and dynamic web solutions.</p>
                <button className='flip-back apply-right-arrow'>
                  Read More
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>

              <div className="flip-card-back it-web">
                <p>Learn about our web development services that deliver responsive, dynamic, and user-friendly websites designed to enhance your online presence and engage your audience.</p>
                <button className='flip-front apply-right-arrow'>
                  Go back
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* card4 */}
          <div className="flip-card" id='card4'>
            <div className="flip-card-inner">
              <div className="flip-card-front flipMobile">
                <h3>Mobile Development</h3>
                <p>Innovative Apps for a Mobile World.<br />
                  Custom mobile app development.</p>
                <button className='flip-back apply-right-arrow'>
                  Read More
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>

              <div className="flip-card-back it-mobile">
                <p>Find out how our app development services can create innovative and user-friendly mobile applications tailored to your business needs, driving engagement and user satisfaction.</p>
                <button className='flip-front apply-right-arrow'>
                  Go back
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* card5 */}
          <div className="flip-card" id='card5'>
            <div className="flip-card-inner">
              <div className="flip-card-front flipNetwork">
                <h3>Network Infrastructure</h3>
                <p>Strengthening Connectivity and Performance.<br />
                  Robust and secure network solutions.</p>
                <button className='flip-back apply-right-arrow'>
                  Read More
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>

              <div className="flip-card-back it-network">
                <p>Explore our network infrastructure services that provide robust, secure, and efficient solutions to enhance your business connectivity and performance.</p>
                <button className='flip-front apply-right-arrow'>
                  Go back
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* card6 */}
          <div className="flip-card" id='card6'>
            <div className="flip-card-inner">
              <div className="flip-card-front flipCloud">
                <h3>Cloud Computing</h3>
                <p>Elevate Your Business with Cloud Power.<br />
                  Scalable and secure cloud solutions.</p>
                <button className='flip-back apply-right-arrow'>
                  Read More
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>

              <div className="flip-card-back it-cloud">
                <p>Discover how our cloud computing services offer scalable and secure solutions to elevate your business operations, improve efficiency, and drive innovation.</p>
                <button className='flip-front apply-right-arrow'>
                  Go back
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>



          {/* card7 */}
          <div className="flip-card" id='card7'>
            <div className="flip-card-inner">
              <div className="flip-card-front flipMachine">
                <h3>AI / Machine Learning</h3>
                <p>Transforming Tomorrow with Intelligent Technology.<br />
                  Innovative AI and Generative Intelligence solutions.</p>
                <button className='flip-back apply-right-arrow'>
                  Read More
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>

              <div className="flip-card-back it-ai">
                <p>Explore how our AI & Generative Intelligence solutions can revolutionize your business operations, enhance decision-making, and drive innovation with cutting-edge technology.</p>
                <button className='flip-front apply-right-arrow'>
                  Go back
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>



          {/* card8 */}
          <div className="flip-card" id='card8'>
            <div className="flip-card-inner">
              <div className="flip-card-front flipCyber">
                <h3>Cyber Security</h3>
                <p>Protecting Your Digital World.<br />
                  Comprehensive cybersecurity solutions.</p>
                <button className='flip-back apply-right-arrow'>
                  Read More
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>

              <div className="flip-card-back it-cyber">
                <p>Discover our cybersecurity services that safeguard your business with comprehensive security measures, protecting against threats and ensuring the integrity of your digital assets.</p>
                <button className='flip-front apply-right-arrow'>
                  Go back
                  <svg
                    className="arrow-icon"
                    fill="none"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                      fill="currentColor"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

        </div>

      </div>

      <hr className="dividenew" />



      <div className="solution-section">
      <p className='subpara'>Our systematic approach ensures a smooth project from start to finish, focusing on your business goals at every stage.</p>
        <h5 className='subHeading'>Working Process</h5>
        

        <div className="solution-container">
          <div className="solution-card process1">
            <div className="step-icon-number" id='no1'>
              {/* <div className="step-number">01</div> */}
              <FontAwesomeIcon icon={faProjectDiagram} />
            </div>
            <h4> Initiate a Project</h4>
            <p>Understand your business needs through detailed discussions, setting a strong foundation and aligning objectives. Our collaborative approach ensures we are all on the same page.</p>
          </div>

          <div className="solution-card process2">
            <div className="step-icon-number" id='no2'>
              {/* <div className="step-number">02</div> */}
              <FontAwesomeIcon icon={faChartLine} />
            </div>
            <h4>Project Analysis</h4>
            <p>Conduct a comprehensive analysis, identify challenges, and create a strategic plan tailored to your goals. We ensure all potential risks are assessed and mitigated.</p>
          </div>

          <div className="solution-card process3">
            <div className="step-icon-number" id='no3'>
              {/* <div className="step-number">03</div> */}
              <FontAwesomeIcon icon={faCogs} />
            </div>
            <h4>Development Execution</h4>
            <p>Execute the project with high-quality development, transparent communication, and timely delivery. Our team focuses on innovation and excellence.</p>
          </div>

          <div className="solution-card process4">
            <div className="step-icon-number" id='no4'>
              {/* <div className="step-number">04</div> */}
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <h4>Seamless Implementation</h4>
            <p> Integrate solutions into your systems with minimal disruption, providing training and support. We ensure a smooth transition and optimal performance.
            </p>
          </div>

          <div className="solution-card process5">
            <div className="step-icon-number" id='no5'>
              {/* <div className="step-number">05</div> */}
              <FontAwesomeIcon icon={faCheckCircle} />
            </div>
            <h4>Continuous Review & Support</h4>
            <p> Review and offer ongoing support post-implementation, ensuring optimal performance and addressing any issues. Our commitment to your success is continuous.</p>
          </div>
        </div>
      </div>


      <hr className="dividenew" />


      <h2 className="industries-title subHeading">Industries</h2>
      <div className="industries-section">

        <div className="industries-flex">
          {/* Technology */}
          <div className="industry">
            <FontAwesomeIcon icon={faMicrochip} className="industry-icon" />
            <p>Technology</p>
          </div>
          {/* Hospital */}
          <div className="industry">
            <FontAwesomeIcon icon={faHospital} className="industry-icon" />
            <p>Hospital</p>
          </div>
          {/* Ecommerce */}
          <div className="industry">
            <FontAwesomeIcon icon={faShoppingCart} className="industry-icon" />
            <p>Ecommerce</p>
          </div>
          {/* Education */}
          <div className="industry">
            <FontAwesomeIcon icon={faBook} className="industry-icon" />
            <p>Education</p>
          </div>
          {/* Banking */}
          <div className="industry">
            <FontAwesomeIcon icon={faUniversity} className="industry-icon" />
            <p>Banking</p>
          </div>
          {/* Travel */}
          <div className="industry">
            <FontAwesomeIcon icon={faSuitcase} className="industry-icon" />
            <p>Travel</p>
          </div>
          {/* FMCG */}
          <div className="industry">
            <FontAwesomeIcon icon={faUtensils} className="industry-icon" />
            <p>FMCG</p>
          </div>
          {/* Hospitality */}
          <div className="industry">
            <FontAwesomeIcon icon={faBed} className="industry-icon" />
            <p>Hospitality</p>
          </div>
          {/* Real Estate */}
          <div className="industry">
            <FontAwesomeIcon icon={faBuilding} className="industry-icon" />
            <p>Real Estate</p>
          </div>
          {/* Automobile */}
          <div className="industry">
            <FontAwesomeIcon icon={faCar} className="industry-icon" />
            <p>Automobile</p>
          </div>
          {/* Logistic & Shipping */}
          <div className="industry">
            <FontAwesomeIcon icon={faTruck} className="industry-icon" />
            <p>Logistic</p>
          </div>
          {/* Manufacturing */}
          <div className="industry">
            <FontAwesomeIcon icon={faIndustry} className="industry-icon" />
            <p>Manufacturing</p>
          </div>
        </div>
      </div>



      {/* <hr className="dividenew" /> */}



      {/* Technologies Carousel */}
      <div className="carousel-container">
        <h2 className='subHeading techhead'>Technologies We Work With</h2>

        <div className="carousel-content">
          <button className="prev-buttonT" onClick={handlePreviousTech}>
            &#10094;
          </button>

          <div className="carousel-slides">
            {visibleTechs.map((tech, index) => (
              <div className="carousel-slide" key={index}>
                <img src={tech.icon} alt={tech.name} />
                <p>{tech.name}</p>
              </div>
            ))}
          </div>

          <button className="next-buttonT" onClick={handleNextTech}>
            &#10095;
          </button>
        </div>
      </div>




      {/* <hr className="dividenew" /> */}


      <div className="why-choose-us-container">
        <div className="why-choose-us-content-wrapper">


          <div className="why-choose-us-title">
            <h2 className='subHeading'>Why Choose Us?</h2>
            <p>
              At Candiclie Consultancy, we provide our clients with exceptional IT solutions that drive success. Here’s why we stand out:
            </p>
          </div>


          <div className="why-choose-us-flex">
            {/* First Box */}
            <div className="why-choose-us-box">
              <div className="why-choose-us-icon" id='icon1'>
                <FaUserTie />
              </div>
              <strong>Skilled Professionals:</strong>
              <p>
                Our experienced expert bring expertise and dedication to every project, ensuring top-quality results.


              </p>
            </div>

            {/* Second Box */}
            <div className="why-choose-us-box">
              <div className="why-choose-us-icon" id='icon2'>
                <FaCogs />
              </div>
              <strong>Customized Solutions:</strong>
              <p>
                We provide customized IT solutions designed to meet your unique business needs and goals.
              </p>
            </div>

            {/* Third Box */}
            <div className="why-choose-us-box">
              <div className="why-choose-us-icon" id='icon3'>
                <FaShieldAlt />
              </div>
              <strong>Dependable Security:</strong>
              <p>
                Our solutions are built with security and reliability in mind, ensuring your business operations run smoothly.
              </p>
            </div>

            {/* Fourth Box */}
            <div className="why-choose-us-box">
              <div className="why-choose-us-icon" id='icon4'>
                <FaHeadset />
              </div>
              <strong>Continuous Support:</strong>
              <p>
                We offer around-the-clock support to address your technical issues and keep your systems running.
              </p>
            </div>
          </div>
        </div>
      </div>



      {/* <hr className="dividenew" /> */}


      <div className="blogs-inner upper-contact-us">
        <p>"Let's Build Your Future Together, <br /> Reach Out and Connect with Us"</p>
        <div className="apply_now upper-contact-us-button">
          <a href="/business-form">
            <button className="apply-right-arrow">
              Connect Now
              <svg
                className="apply-right-arrow"
                fill="none"
                height="24"
                viewBox="0 0 24 24"
                width="24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </a>
        </div>
      </div>

      <hr className="dividenew" />



      <div className="blog-section">

        <h2 className="subHeading">Our Blogs</h2>


        <div className="blog-slider">
          {/* Blog 1 */}
          <div className="blog-content blog-1">
            <h3>Artificial Intelligence</h3>
            <h4>How AI And ML Will Impact Software Testing In 2024</h4>
            <p>
              Software testing or Quality Assurance is a key step in the development process of any product...
            </p>
          </div>

          {/* Blog 2 */}
          <div className="blog-content blog-2">
            <h3>Website Development</h3>
            <h4>Custom Web Application Development Services</h4>
            <p>
              Consumers have become smart when it comes to online marketing, hence any business must have...
            </p>
          </div>

          {/* Blog 3 */}
          <div className="blog-content blog-3">
            <h3>Software Development</h3>
            <h4>The Evolution of Custom Software Development</h4>
            <p>
              As businesses evolve, so does the demand for custom software to meet the specific needs.
            </p>
          </div>
        </div>

        <div className="blogs-button-containerR">
          <a href="/blogs" className="blogs-btnR apply-right-arrow">
            Explore More
            <svg
              className="arrow-icon"
              fill="none"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>

      </div>





      <hr className="dividenew" />


      <div className="business-hero">
        <div className="main-contentnew">
          <h1>Explore More Possibilities - Return to Our Home Page</h1>
          <a href="/home" className="main-button apply-right-arrow">
            Go Back
            <svg
              className="arrow-icon"
              fill="none"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.5253 5.49475L10.5206 7.49475L15.0782 7.50541L5.47473 17.0896L6.88752 18.5052L16.5173 8.89479L16.5065 13.5088L18.5065 13.5134L18.5253 5.51345L10.5253 5.49475Z"
                fill="currentColor"
              />
            </svg>
          </a>
        </div>
      </div>

      <hr className="dividenew" />




      <Chatbot/>

    </div>
  )}
  </>
);
};

export default ITServicesPage;
